export interface SupportFormData {
  name: string;
  email: string;
  paymentDate: string;
  transactionAmount: string;
  message: string;
  file?: File | null;
}

export interface FormErrors {
  name?: string;
  email?: string;
  paymentDate?: string;
  transactionAmount?: string;
  message?: string;
  file?: string;
}

export interface FormTouched {
  name: boolean;
  email: boolean;
  paymentDate: boolean;
  transactionAmount: boolean;
  message: boolean;
  file: boolean;
}

export interface FormState {
  data: SupportFormData;
  errors: FormErrors;
  touched: FormTouched;
  isValid: boolean;
  isSubmitting: boolean;
  isSubmitted: boolean;
}

export const INITIAL_FORM_DATA: SupportFormData = {
  name: '',
  email: '',
  paymentDate: '',
  transactionAmount: '',
  message: '',
  file: null
};

export const INITIAL_FORM_TOUCHED: FormTouched = {
  name: false,
  email: false,
  paymentDate: false,
  transactionAmount: false,
  message: false,
  file: false
};

export const ALLOWED_FILE_TYPES = [
  'image/jpeg',
  'image/jpg', 
  'image/png',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
];

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
